var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [
        _vm._v(
          _vm._s(_vm.$t("components.sale-layout-editor.upload-template.title"))
        ),
      ]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-file-upload", {
                    attrs: {
                      "max-size": 5e6,
                      sending: _vm.sending,
                      label: _vm.$t(
                        "components.sale-layout-editor.upload-template.label"
                      ),
                      "allowed-extensions": _vm.allowedExtensions,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onFile($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.fileName
                ? _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-link",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.removeFile()
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            staticClass: "mr",
                            attrs: { icon: "times" },
                          }),
                          _vm._v(_vm._s(_vm.fileName)),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.layout, icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }